/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DocumentFigureURL } from '../model';
/**
 * FiguresApi - axios parameter creator
 * @export
 */
export const FiguresApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * IDで指定された書籍の図表の画像をストレージから取得し、エンドユーザがアクセスできるURLとして返す
         * @summary 書籍内の画像のURLを取得する
         * @param {string} id 
         * @param {string} figureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentFigureUrl: async (id: string, figureId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentFigureUrl', 'id', id)
            // verify required parameter 'figureId' is not null or undefined
            assertParamExists('getDocumentFigureUrl', 'figureId', figureId)
            const localVarPath = `/documents/{id}/figures/{figureId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"figureId"}}`, encodeURIComponent(String(figureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FiguresApi - functional programming interface
 * @export
 */
export const FiguresApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FiguresApiAxiosParamCreator(configuration)
    return {
        /**
         * IDで指定された書籍の図表の画像をストレージから取得し、エンドユーザがアクセスできるURLとして返す
         * @summary 書籍内の画像のURLを取得する
         * @param {string} id 
         * @param {string} figureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentFigureUrl(id: string, figureId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentFigureURL>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentFigureUrl(id, figureId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FiguresApi - factory interface
 * @export
 */
export const FiguresApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FiguresApiFp(configuration)
    return {
        /**
         * IDで指定された書籍の図表の画像をストレージから取得し、エンドユーザがアクセスできるURLとして返す
         * @summary 書籍内の画像のURLを取得する
         * @param {string} id 
         * @param {string} figureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentFigureUrl(id: string, figureId: string, options?: any): AxiosPromise<DocumentFigureURL> {
            return localVarFp.getDocumentFigureUrl(id, figureId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FiguresApi - interface
 * @export
 * @interface FiguresApi
 */
export interface FiguresApiInterface {
    /**
     * IDで指定された書籍の図表の画像をストレージから取得し、エンドユーザがアクセスできるURLとして返す
     * @summary 書籍内の画像のURLを取得する
     * @param {string} id 
     * @param {string} figureId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiguresApiInterface
     */
    getDocumentFigureUrl(id: string, figureId: string, options?: AxiosRequestConfig): AxiosPromise<DocumentFigureURL>;

}

/**
 * FiguresApi - object-oriented interface
 * @export
 * @class FiguresApi
 * @extends {BaseAPI}
 */
export class FiguresApi extends BaseAPI implements FiguresApiInterface {
    /**
     * IDで指定された書籍の図表の画像をストレージから取得し、エンドユーザがアクセスできるURLとして返す
     * @summary 書籍内の画像のURLを取得する
     * @param {string} id 
     * @param {string} figureId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiguresApi
     */
    public getDocumentFigureUrl(id: string, figureId: string, options?: AxiosRequestConfig) {
        return FiguresApiFp(this.configuration).getDocumentFigureUrl(id, figureId, options).then((request) => request(this.axios, this.basePath));
    }
}
